import { Button } from "@/components/ui/button";
import { MoreLink } from "@/components/ui/more-link";
import { Page } from "@/components/ui/page";
import { EmptyState, Panel } from "@/components/ui/panel";
import { Link } from "react-router";

export function NotFoundPage() {
  return (
    <Page art="not-found" mood="empty" title="ページが見つかりません" crumbs={[{ label: "ページが見つかりません" }]}>
      <Panel>
        <EmptyState photo="not-found" title="お探しのページは見つかりませんでした">
          <p>大変申し訳ございません。次のような理由が考えられます。</p>
          <ul className="mt-2 inline-block list-disc pl-5 text-left">
            <li>URL が変更された、または入力に誤りがある</li>
            <li>このページを閲覧する権限がない</li>
            <li>記事や事務所が削除された</li>
          </ul>
        </EmptyState>
        <div className="flex flex-wrap items-center justify-center gap-4 pb-4">
          <Button asChild><Link to="/">ホームへ戻る</Link></Button>
          <MoreLink to="/account">アカウント設定</MoreLink>
        </div>
      </Panel>
    </Page>
  );
}
